<template lang="html">
  <div>
    <p class="go-to text-center">
      <span v-if="showArrow" class="material-icons go-to__arrow">
        arrow_back
      </span>

      <span class="go-to__message label" v-if="message">
        {{ message }}
      </span>
      <span
        class="link label"
        :data-testid="testId"
        v-on:click="$emit('onClickGoTo', $event)"
      >
        {{ linkMessage }}
      </span>
    </p>
  </div>
</template>

<script>
/**
 * Emitters
 *
 * onClickGoTo
 */
export default {
  props: {
    showArrow: {
      type: Boolean,
      required: false,
      default: true,
    },
    message: {
      type: String,
      required: false,
    },
    linkMessage: {
      type: String,
      required: true,
    },
    testId: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.go-to {
  &__arrow {
    color: $color-blue-grey-lighten1;
    margin-right: 4px;
    vertical-align: middle;
    font-size: 18px;
  }

  &__message {
    color: $color-blue-grey-darken2;
    padding: 0;
  }
}

.link {
  padding: 0;
  cursor: pointer;
  color: $color-blue;
}
</style>
